<template>
  <div class="header-languages" v-if="authorized.length > 1">
    <ul>
      <li
        v-for="(item) in authorized"
        :key="item"
      >
        <router-link :to="`/${item}`">
          <span>{{ item.toUpperCase() }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TheHeaderLanguages',
  computed: {
    ...mapState('languages', [
      'authorized'
    ])
  }
}
</script>

<style lang="scss">
.header-languages{
  /* display: none; */

  ul{
    @include no-type-list;
    display: flex;
    justify-content: flex-start;
  }

  li{
    padding: 0 layout("spacing")/3;
  }

  a{
    @include add-hover-underline;
    @include add-transition;
    @include text-color(white, white);
    text-decoration: none;
    color: rgba(white, 0.3);
  }
}
</style>
